import { defineMessages } from 'react-intl';

export default defineMessages({
  // main-menu
  dashboard: {
    id: 'Header.config.professional.dashboard',
    defaultMessage: 'Dashboard',
    description: 'item dashboard dans la usernav',
  },
  conversations: {
    id: 'Header.config.professional.conversations',
    defaultMessage: 'Messages',
    description: 'item conversations dans la usernav',
  },
  appointments: {
    id: 'Header.config.professional.appointments',
    defaultMessage: 'Rendez-vous',
    description: 'item appointments dans la usernav',
  },

  // usernav
  profile: {
    id: 'Header.config.professional.profile',
    defaultMessage: 'Profil',
    description: 'item profil dans la usernav',
  },
  settings: {
    id: 'Header.config.professional.settings',
    defaultMessage: 'Paramètres',
    description: 'item setting dans la usernav',
  },
  moderations: {
    id: 'Header.config.professional.moderations',
    defaultMessage: 'Modération',
    description: 'item Moderation dans la usernav',
  },
  fdrConfiguration: {
    id: 'Header.config.professional.fdrConfiguration',
    defaultMessage: 'Configuration',
    description: 'item Moderation dans la usernav',
  },
  mjgChronos: {
    id: 'Header.config.professional.mjgChronos',
    defaultMessage: 'Admin MJG',
    description: 'item deconnexion dans la usernav',
  },
  logout: {
    id: 'Header.config.professional.logout',
    defaultMessage: 'Se déconnecter',
    description: 'item deconnexion dans la usernav',
  },
  employeeMode: {
    id: 'Header.config.professional.adminMode',
    defaultMessage: 'Mode admin',
    description: 'switch vers le mode admin dans le header',
  },
});
